import { IReport, IReports } from "../../../../models/master/reports";
import { baseURL } from "../../../../constants/commonConstants";
import { IDailyReoprts } from "../../../../models/dashboard/staffReports/staffReports";
import { getReports } from "../../../../action/masters/reportActionCreator";
import { connect, useDispatch } from "react-redux";
import { useEffect } from "react";
import { limit, pageBlockId } from "../../../../constants/pageBlocks";
import { ReportFrequency } from "../../../../models/dashboard/adminDashboard";
import { setReportsDaily } from "../../../../store/slices/master/reportSlice";
import { useNavigate } from "react-router-dom";
import { ROUTER_URL } from "../../../../constants/routerUrl";
import { getPageBlockData } from "../../../../common-functions/commonFunctions";

const StaffDailyReports = (props: IDailyReoprts) => {
  const { getDailyReports, dailyReports, snapShots } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleViewALL = () => {
    navigate(ROUTER_URL.STAFF_ALL_DAILY_REPORTS);
  };

  const pageBlockData = getPageBlockData(
    snapShots,
    pageBlockId.reportResources
  );

  useEffect(() => {
    if (pageBlockData?.displayOrNot) {
      getDailyReports(
        pageBlockId.reportResources,
        limit.three,
        ReportFrequency.Daily
      );
    }
  }, [pageBlockData]);

  useEffect(() => {
    return () => {
      dispatch(setReportsDaily([]));
    };
  }, []);
  return (
    <>
      <div className="col-lg-12">
        <div
          className={
            pageBlockData?.displayOrNot
              ? "card-wrap"
              : "card-wrap card-snapshot"
          }
          style={
            pageBlockData?.displayOrNot === false
              ? { backgroundImage: `url(${baseURL + pageBlockData.image})` }
              : {}
          }
        >
          <div className="title">
            <h2>Daily Reports</h2>
            <a
              onClick={handleViewALL}
              className={
                pageBlockData?.displayOrNot ? "btn-link" : "btn-link d-none"
              }
              title="View All Daily Reports"
            >
              View All
            </a>
          </div>
          <div className="acc-resource row">
            {dailyReports?.map((report: IReports, index) => (
              <div className="col-lg-4" key={index}>
                <a href={report.url} target="_blank">
                  <div className="card d-flex align-items-start flex-column">
                    <div className="reportimg">
                      <img src={baseURL + report.icon} alt="" />
                    </div>
                    <h2 className="para-hide-1">{report.name}</h2>
                    <p className="para-hide-2">{report.description}</p>
                  </div>
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

const mapDispatchToProps = {
  getDailyReports: (
    pageBlockId: number,
    noOfItems: number,
    ReportFrequency: number
  ) => getReports(undefined, pageBlockId, noOfItems, ReportFrequency),
};

function mapStateToProps(state: any) {
  return {
    dailyReports: state.report.dailyreports,
    snapShots: state.snapShot.snapShots,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(StaffDailyReports);
